var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fbb03b;}")),React.createElement("path",{"className":"a","d":"M22.214,59.882H2.3A2.3,2.3,0,0,0,0,62.18V75.968a2.3,2.3,0,0,0,2.3,2.3H22.214a2.3,2.3,0,0,0,2.3-2.3V62.18A2.3,2.3,0,0,0,22.214,59.882Zm0,1.532a.762.762,0,0,1,.294.059L12.256,70.358,2,61.473a.762.762,0,0,1,.294-.059Zm0,15.32H2.3a.767.767,0,0,1-.766-.766V63.092l10.222,8.859a.767.767,0,0,0,1,0L22.98,63.092V75.968A.767.767,0,0,1,22.214,76.734Z","transform":"translate(0 -59.882)","key":1})]);
}

Email.defaultProps = {"width":"24.512","height":"18.384","viewBox":"0 0 24.512 18.384"};

module.exports = Email;

Email.default = Email;
